import {
  Avatar,
  CircularProgress,
  FormControl,
  InputAdornment,
  InputLabel,
  Stack,
  TextField,
  Tooltip,
  Box,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  Chip,
  Link,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { useEffect, useRef, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useSnackbar } from "notistack";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import EditIcon from "@mui/icons-material/Edit";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import { s3baseUrl } from "src/config/config";
import ToshowExercise from "./component/modalToshowExercise";
import ConfirmationWithDescription from "src/components/ConfirmationWithDescription";
import AMRAPExercisesUI from "./AMRAPExercisesUI";
import EMOMExercisesUI from "./EMOMExercisesUI";
import SomeThingElseExercisesUI from "./SomeThingElseExercisesUI";
import {
  formatWithLeadingZeros,
  getPaceTextinPaces,
  paceFromVdot,
  getMihr,
  getKmhr,
  getPaceText,
  getMihrForPace,
  getKmhrForPace,
  getOptionsByValue,
  super_set_item,
  exercise_history,
} from "src/utils/constants";
import { programme_workout_exercise_history_list_api } from "src/DAL/programmeWorkout/programmeWorkout";
import { Icon } from "@iconify/react";
import ExerciseHistoryModel from "./component/ExerciseHistoryModel";
import ModalToShowAnExerciseInfo from "./component/ModalToShowAnExerciseInfo";
import RoundsForTimeExercisesUI from "./RoundsForTimeExercisesUI";
import RepsForTimeExercisesUI from "./RepsForTimeExercisesUI";

const useStyles = makeStyles(() => ({
  loading2: {
    position: "fixed",
    top: "50%",
    right: "50%",
    zIndex: 1000,
  },
}));

const findPaceObjectByVdot = (vdotValue) => {
  return paceFromVdot.find((paceObject) => paceObject.vdot == vdotValue);
};
const WorkoutExercisesAnswerUI = ({
  addArray,
  setaddArray,
  setModalChangeExe,
  original,
  isWorkoutCompleted,
  setIsWorkoutCompleted,
  memberRewardData,
  practiceType,
  handleSubmit,
  member_vdot,
}) => {
  const [openExerciseAlert, setOpenExerciseAlert] = useState(false);
  const [openSuperSetAlert, setOpenSuperSetAlert] = useState(false);
  const [historyModalData, setHistoryModalData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [detailsData, setDetailsData] = useState("");
  const [exerIndex, setExerIndex] = useState("");
  const [openSingleExerciseInfo, setOpenSingleExerciseInfo] = useState(false);
  const [singleExerciseInfo, setSingleExerciseInfo] = useState("");
  const [openDetails, setOpenDetails] = useState(false);
  const [isHovered, setIsHovered] = useState("");
  const [isHoveredExercise, setIsHoveredExercise] = useState("");
  const [isExerciseForSuperSet, setIsExerciseForSuperSet] = useState(false);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [historyModalOpenSuperset, setHistoryModalOpenSuperset] =
    useState(false);
  const classes = useStyles();
  const handleMouseEnter = (setIndex, exerciseIndex) => {
    setIsHovered(setIndex);
    setIsHoveredExercise(exerciseIndex);
  };
  const timeoutRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  const maxLength = 250;

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleMouseLeave = () => {
    const delay = 1000;
    timeoutRef.current = setTimeout(() => {
      setIsHovered("");
    }, delay);
  };

  const handleAddSet = (mainindex, index) => {
    let list = addArray;
    const data = { ...list[mainindex]["set"][index] };
    list[mainindex]["set"].splice(index + 1, 0, data);

    setModalChangeExe(true);
    setaddArray([...list]);
  };

  const handleDeleteSet = (mainindex, index) => {
    let list = addArray;
    list[mainindex]["set"].splice(index, 1);
    setModalChangeExe(true);
    setaddArray([...list]);
  };

  const handleAgreeInSuperSet = () => {
    const list = [...addArray];
    list[detailsData]["superSet"][exerIndex]["is_completed"] = false;
    setIsWorkoutCompleted(false);
    setModalChangeExe(true);
    setOpenSuperSetAlert(false);
    setaddArray(list);
  };

  const handleAgreeInExerciseSet = () => {
    const list = [...addArray];
    list[exerIndex]["is_completed"] = false;
    setIsWorkoutCompleted(false);
    setModalChangeExe(true);
    setOpenExerciseAlert(false);
    setaddArray(list);
  };

  const handleChangeComplete = (e, index) => {
    const { checked } = e.target;
    const list = [...addArray];
    if (!checked && isWorkoutCompleted) {
      setExerIndex(index);
      setOpenExerciseAlert(true);
      return;
    }
    list[index]["is_completed"] = checked;

    setModalChangeExe(true);
    setaddArray(list);

    if (checked) {
      handleSubmit(true, true);
    }
  };

  const handleArrow = (value, index) => {
    const list = [...addArray];
    list[index]["open"] = value;
    setaddArray(list);
  };

  const handleChangeCompleteSet = (e, mainindex, exerIndex) => {
    const { checked } = e.target;
    const list = [...addArray];
    if (!checked && isWorkoutCompleted) {
      setDetailsData(mainindex);
      setExerIndex(exerIndex);
      setOpenSuperSetAlert(true);
      return;
    }
    list[mainindex]["superSet"][exerIndex]["is_completed"] = checked;
    setModalChangeExe(true);
    setaddArray(list);

    if (checked) {
      handleSubmit(true, true);
    }
  };

  const handleArrowSuperSet = (value, mainindex, exerIndex) => {
    const list = [...addArray];
    list[mainindex]["superSet"][exerIndex]["open"] = value;
    setaddArray(list);
  };

  const handleChange = (e, index, index1) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[index]["set"][index1][name] = value;
    setModalChangeExe(true);
    setaddArray(list);
  };

  const getVdotPace = (index, index1) => {
    const list = [...addArray];
    const vodt = list[index]["set"][index1]["vdot"];
    const distanceType = list[index]["set"][index1]["race_type"];
    const paceType = list[index]["set"][index1]["pace_type"];

    const vdot33Object = findPaceObjectByVdot(vodt);
    if (distanceType != "el") {
      list[index]["set"][index1]["pace"] = vdot33Object[paceType];
    } else {
      list[index]["set"][index1]["pace"] = vdot33Object[paceType + "_low"];
      list[index]["set"][index1]["paceUp"] = vdot33Object[paceType + "_up"];
    }
    setaddArray(list);
  };

  const handleHistoryOpen = async (value, index) => {
    setDetailsData(index);
    handleHistory(value?.exercise, index);
  };

  const handleHistory = async (value, index) => {
    setDetailsData(index);
    let postData = {
      exercise: value?._id,
    };
    setHistoryModalData([]);
    setIsLoading(true);
    try {
      let result = await programme_workout_exercise_history_list_api(postData);
      if (result.code == 200) {
        if (!result.exercise_history.length > 0) {
          const list = [...addArray];
          delete list[index]["history"];
          setaddArray(list);

          return;
        }
        let givenExercise = result.exercise_history.map((item) => {
          return exercise_history(item);
        });
        setHistoryModalData(givenExercise);
        const list = [...addArray];
        list[index]["history"] = givenExercise;
        setaddArray(list);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
      setHistoryModalOpen(true);
    }
  };

  const handleHistorySupersetOpen = async (value, mainIndex, exerInde) => {
    setDetailsData(mainIndex);
    setExerIndex(exerInde);
    handleHistorySuperset(value.exercise, mainIndex, exerInde);
  };

  const handleHistorySuperset = async (value, mainIndex, exerInde) => {
    setDetailsData(mainIndex);
    setExerIndex(exerInde);
    let postData = {
      exercise: value?._id,
    };
    setHistoryModalData([]);
    setIsLoading(true);
    let result = await programme_workout_exercise_history_list_api(postData);
    if (result.code == 200) {
      const list = [...addArray];

      if (!list[mainIndex]["superSet"][exerInde]["history"])
        list[mainIndex]["superSet"][exerInde]["history"] = [];

      if (!result.exercise_history.length > 0) {
        delete list[mainIndex]["superSet"][exerInde]["history"];
        setaddArray(list);
        setIsLoading(false);
        setHistoryModalOpenSuperset(true);
        return;
      }
      let givenExercise = result.exercise_history.map((item) => {
        return exercise_history(item);
      });
      setHistoryModalData(givenExercise);
      list[mainIndex]["superSet"][exerInde]["history"] = givenExercise;
      setaddArray(list);
      setIsLoading(false);
      setHistoryModalOpenSuperset(true);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleChangeVdotPaceType = (e, index, index1) => {
    const { name, value } = e.target;

    const list = [...addArray];

    list[index]["set"][index1][name] = value;
    setaddArray(list);
    setModalChangeExe(true);
    getVdotPace(index, index1);
  };

  const handleChangeVdotDistance = (e, index, index1) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[index].set[index1][name] = value;

    const optionsTypeSArray = getOptionsByValue(value);
    list[index].set[index1]["optionsType"] = optionsTypeSArray;
    list[index].set[index1]["pace_type"] = optionsTypeSArray[0].key;

    setaddArray(list);
    setModalChangeExe(true);
    getVdotPace(index, index1);
  };

  const handleChangeTempo = (e, index, index1) => {
    const { name, value } = e.target;
    if (value.length <= 4) {
      const list = [...addArray];
      list[index]["set"][index1][name] = value;
      setaddArray(list);
      setModalChangeExe(true);
    }
  };

  const handleChangeSuperSetTempo = (e, mainindex, exerIndex, setIndex) => {
    const { name, value } = e.target;
    if (value.length <= 4) {
      const list = [...addArray];
      list[mainindex]["superSet"][exerIndex]["set"][setIndex][name] = value;
      setaddArray(list);
      setModalChangeExe(true);
    }
  };

  const handleChangeSuperSet = (e, mainindex, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];
    list[mainindex]["superSet"][exerIndex]["set"][setIndex][name] = value;
    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleAddSetCount = (index) => {
    const list = [...addArray];
    const name = "superset_sets";
    const value = parseInt(list[index].superset_sets) + 1;
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));

    list[index][name] = targetValue;

    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;
      const data = { ...superSetItem.set[currentSetLength - 1] };
      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;
        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push(data);
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });

    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleMinusSetCount = (index) => {
    const list = [...addArray];
    const name = "superset_sets";
    const value = parseInt(list[index].superset_sets) - 1;
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));
    list[index][name] = targetValue;
    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;

      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;
        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({
            ...super_set_item,
          });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });
    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleChangeSuperSetCount = (e, index) => {
    const { name, value } = e.target;
    const list = [...addArray];
    const targetValue = value === "" ? 1 : Math.max(1, parseInt(value, 10));
    list[index][name] = targetValue;

    list[index]?.superSet.forEach((superSetItem) => {
      const currentSetLength = superSetItem.set.length;

      if (currentSetLength < targetValue) {
        const objectsToAdd = targetValue - currentSetLength;

        for (let i = 0; i < objectsToAdd; i++) {
          superSetItem.set.push({
            ...super_set_item,
          });
        }
      } else if (currentSetLength > targetValue) {
        superSetItem.set.splice(targetValue);
      }
    });

    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleExerciseList = (value) => {
    setIsExerciseForSuperSet(false);
    setDetailsData(value);
    setOpenDetails(true);
  };

  const handleSupersetExerciseList = (mainIndex, exerInde) => {
    setDetailsData(mainIndex);
    setExerIndex(exerInde);
    setIsExerciseForSuperSet(true);
  };

  const handleClickOpen = async (exercise) => {
    setSingleExerciseInfo(exercise);
    setOpenSingleExerciseInfo(true);
  };

  const handleSelectExercise = (value) => {
    if (addArray[detailsData]["exercise"]._id == value._id) {
      return;
    }

    const list = [...addArray];
    list[detailsData]["exercise"] = value;
    list[detailsData]["description"] = value?.instructions;

    if (original[detailsData]["exercise"]._id == value._id) {
      list[detailsData]["is_modified"] = original[detailsData]["is_modified"];
    } else list[detailsData]["is_modified"] = true;

    list[detailsData]["open"] = true;

    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleSelectSupersetExercise = (value) => {
    const list = [...addArray];
    list[detailsData]["superSet"][exerIndex]["exercise"] = value;
    list[detailsData]["superSet"][exerIndex]["description"] =
      value?.instructions;

    if (
      original[detailsData] &&
      original[detailsData]["superSet"] &&
      original[detailsData]["superSet"][exerIndex]["exercise"] &&
      original[detailsData]["superSet"][exerIndex]["exercise"]._id == value._id
    ) {
      list[detailsData]["superSet"][exerIndex]["is_modified"] =
        original[detailsData]["superSet"][exerIndex]["is_modified"];
    } else list[detailsData]["superSet"][exerIndex]["is_modified"] = true;
    list[detailsData]["superSet"][exerIndex]["open"] = true;

    setModalChangeExe(true);
    setaddArray(list);
  };

  const handleMinutesChange = (e, index, index1) => {
    const { name, value } = e.target;
    const list = [...addArray];

    const minutes = parseInt(e.target.value) || 0;
    const seconds = list[index]["set"][index1][name] % 60;
    updateIntervalTime(minutes, seconds, index, index1, name);
  };

  const handleSecondsChange = (e, index, index1) => {
    const { name, value } = e.target;
    const list = [...addArray];

    let seconds = parseInt(e.target.value) || 0;
    seconds = Math.min(Math.max(seconds, 0), 59); // Ensure the value is between 0 and 60
    const minutes = Math.floor(list[index]["set"][index1][name] / 60);
    updateIntervalTime(minutes, seconds, index, index1, name);
  };

  const updateIntervalTime = (minutes, seconds, index, index1, name) => {
    const totalSeconds = minutes * 60 + seconds;
    const list = [...addArray];
    list[index]["set"][index1][name] = totalSeconds;
    setaddArray(list);
    setModalChangeExe(true);
  };

  const handleMinutesChangeSets = (e, mainindex, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];
    const minutes = parseInt(e.target.value) || 0;
    const seconds =
      list[mainindex]["superSet"][exerIndex]["set"][setIndex][name] % 60;
    updateIntervalTimeSets(
      minutes,
      seconds,
      mainindex,
      exerIndex,
      setIndex,
      name,
    );
  };

  const handleSecondsChangeSets = (e, mainindex, exerIndex, setIndex) => {
    const { name, value } = e.target;
    const list = [...addArray];

    let seconds = parseInt(e.target.value) || 0;
    seconds = Math.min(Math.max(seconds, 0), 59); // Ensure the value is between 0 and 60
    const minutes = Math.floor(
      list[mainindex]["superSet"][exerIndex]["set"][setIndex][name] / 60,
    );
    updateIntervalTimeSets(
      minutes,
      seconds,
      mainindex,
      exerIndex,
      setIndex,
      name,
    );
  };

  const updateIntervalTimeSets = (
    minutes,
    seconds,
    mainindex,
    exerIndex,
    setIndex,
    name,
  ) => {
    const totalSeconds = minutes * 60 + seconds;
    const list = [...addArray];
    list[mainindex]["superSet"][exerIndex]["set"][setIndex][name] =
      totalSeconds;
    setaddArray(list);
    setModalChangeExe(true);
  };

  return (
    <div className="w-100">
      {isLoading && (
        <CircularProgress className={classes.loading2} color="primary" />
      )}

      <ConfirmationWithDescription
        open={openSuperSetAlert}
        setOpen={setOpenSuperSetAlert}
        title={"Are you sure you want to taaaake this action?"}
        descriotion={`If you uncheck, your points or coins allocated for this ${practiceType} will be deducted.`}
        handleAgree={handleAgreeInSuperSet}
        isJustForOk={false}
      />
      <ConfirmationWithDescription
        open={openExerciseAlert}
        setOpen={setOpenExerciseAlert}
        title={"Are you sure you want to take this action?"}
        descriotion={`If you uncheck, your points or coins allocated for this ${practiceType} will be deducted.`}
        handleAgree={handleAgreeInExerciseSet}
        isJustForOk={false}
      />
      {openSingleExerciseInfo && (
        <ModalToShowAnExerciseInfo
          open={openSingleExerciseInfo}
          setOpen={setOpenSingleExerciseInfo}
          Id={singleExerciseInfo}
        />
      )}
      {openDetails && (
        <ToshowExercise
          open={openDetails}
          setOpen={setOpenDetails}
          handleChange={handleSelectExercise}
        />
      )}
      {isExerciseForSuperSet && (
        <ToshowExercise
          open={isExerciseForSuperSet}
          setOpen={setIsExerciseForSuperSet}
          handleChange={handleSelectSupersetExercise}
        />
      )}
      {historyModalOpen && (
        <ExerciseHistoryModel
          open={historyModalOpen}
          setOpen={setHistoryModalOpen}
          data={historyModalData}
          handleChange={setHistoryModalData}
          handleCopyExercise={() => {}}
        />
      )}
      {historyModalOpenSuperset && (
        <ExerciseHistoryModel
          open={historyModalOpenSuperset}
          setOpen={setHistoryModalOpenSuperset}
          data={historyModalData}
          handleChange={setHistoryModalData}
          handleCopyExercise={() => {}}
        />
      )}
      <div className="mt-2 ">
        <div className="characters">
          {addArray?.map((data, mainindex) => {
            return (
              <>
                {data?.type == "something_else" ? (
                  <SomeThingElseExercisesUI
                    addArray={addArray}
                    setaddArray={setaddArray}
                    setModalChangeExe={setModalChangeExe}
                    mainindex={mainindex}
                    isHistory={false}
                    memberId={""}
                    isWorkoutCompleted={isWorkoutCompleted}
                    setIsWorkoutCompleted={setIsWorkoutCompleted}
                    memberRewardData={memberRewardData}
                    practiceType={practiceType}
                    handleSubmit={handleSubmit}
                  />
                ) : data?.type == "amrap" ? (
                  <AMRAPExercisesUI
                    addArray={addArray}
                    setaddArray={setaddArray}
                    setModalChangeExe={setModalChangeExe}
                    mainindex={mainindex}
                    isHistory={false}
                    memberId={""}
                    isWorkoutCompleted={isWorkoutCompleted}
                    setIsWorkoutCompleted={setIsWorkoutCompleted}
                    memberRewardData={memberRewardData}
                    practiceType={practiceType}
                    handleSubmit={handleSubmit}
                    member_vdot={member_vdot}
                  />
                ) : data?.type == "rounds_for_time" ? (
                  <RoundsForTimeExercisesUI
                    addArray={addArray}
                    setaddArray={setaddArray}
                    setModalChangeExe={setModalChangeExe}
                    mainindex={mainindex}
                    isHistory={false}
                    memberId={""}
                    isWorkoutCompleted={isWorkoutCompleted}
                    setIsWorkoutCompleted={setIsWorkoutCompleted}
                    memberRewardData={memberRewardData}
                    practiceType={practiceType}
                    member_vdot={member_vdot}
                    handleSubmit={handleSubmit}
                  />
                ) : data?.type == "reps_for_time" ? (
                  <RepsForTimeExercisesUI
                    addArray={addArray}
                    setaddArray={setaddArray}
                    setModalChangeExe={setModalChangeExe}
                    mainindex={mainindex}
                    isHistory={false}
                    memberId={""}
                    isWorkoutCompleted={isWorkoutCompleted}
                    setIsWorkoutCompleted={setIsWorkoutCompleted}
                    memberRewardData={memberRewardData}
                    practiceType={practiceType}
                    member_vdot={member_vdot}
                    handleSubmit={handleSubmit}
                  />
                ) : data?.type == "emom" ? (
                  <EMOMExercisesUI
                    addArray={addArray}
                    setaddArray={setaddArray}
                    setModalChangeExe={setModalChangeExe}
                    mainindex={mainindex}
                    isHistory={false}
                    memberId={""}
                    isWorkoutCompleted={isWorkoutCompleted}
                    setIsWorkoutCompleted={setIsWorkoutCompleted}
                    memberRewardData={memberRewardData}
                    practiceType={practiceType}
                    member_vdot={member_vdot}
                    handleSubmit={handleSubmit}
                  />
                ) : data?.superSet && data?.superSet.length > 0 ? (
                  <>
                    <div
                      style={{ position: "relative" }}
                      className="workout-Superset-card my-2"
                    >
                      <Box>
                        <div className="d-flex align-items-start justify-content-between ">
                          <div className="d-flex align-items-center w-100  mb-2">
                            <div>Superset of</div>
                            <div className="ms-2 cross-icon ">
                              <RemoveCircleIcon
                                onClick={() => handleMinusSetCount(mainindex)}
                                className="diary-icon-plus-minus"
                              />
                            </div>

                            <TextField
                              id="outlined-basic"
                              size="small"
                              variant="outlined"
                              placeholder="Sets"
                              type="number"
                              value={data.superset_sets}
                              name="superset_sets"
                              disabled
                              onChange={(e) =>
                                handleChangeSuperSetCount(e, mainindex)
                              }
                              InputLabelProps={{
                                shrink: true,
                                style: { fontSize: "14px" },
                              }}
                              //   label="Set"
                              InputProps={{
                                className: "textfiels-input-value",
                                style: { fontSize: "13px", padding: "0" },
                              }}
                              sx={{
                                mx: 1,
                                borderRadius: "5px",
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                fontSize: "13px",
                                "& input": {
                                  padding: "3px 5px",
                                  textAlign: "center",
                                },
                                width: "30px",
                              }}
                            />

                            <div className=" cross-icon me-2">
                              <AddCircleIcon
                                onClick={() => handleAddSetCount(mainindex)}
                                className="diary-icon-plus-minus"
                              />
                            </div>
                            <div>sets</div>
                          </div>
                        </div>

                        <div className=" mb-2 ">
                          {data?.superSet?.map((exerData, exerIndex) => (
                            <div
                              className="d-flex  workout-set-card"
                              style={{
                                position: "relative",
                                width: "100%",
                                overflow: "hidden",
                              }}
                            >
                              <Box
                                sx={{
                                  width: "100%",
                                }}
                              >
                                <div
                                  className="row  "
                                  onMouseEnter={() => handleMouseLeave()}
                                >
                                  <div
                                    className={`col-sm-12 ${"col-md-7"} col-lg-6 d-flex align-items-center p-0 mt-2 mt-md-0 mt-lg-0`}
                                  >
                                    {exerData?.is_modified && (
                                      <span
                                        style={{
                                          position: "absolute",
                                          top: "10px",
                                          justifyContent: "center",
                                          zIndex: "1",
                                          left: "-18px",
                                          transform: "rotate(-53deg)",
                                        }}
                                      >
                                        <Chip
                                          label={"Modified"}
                                          variant="contained"
                                          color={"error"}
                                          sx={{
                                            fontSize: "10px",
                                            height: "auto",
                                            width: "auto",
                                          }}
                                        />
                                      </span>
                                    )}
                                    <div className="exercise-label-box">
                                      <span className="outer-label">
                                        Exercise
                                      </span>
                                      <div className="d-flex align-items-center justify-content-between">
                                        <div
                                          className="exercise-label w-100"
                                          onClick={() =>
                                            handleSupersetExerciseList(
                                              mainindex,
                                              exerIndex,
                                            )
                                          }
                                        >
                                          <div className="d-flex align-items-center">
                                            {exerData?.exercise?.image
                                              ?.thumbnail_3 && (
                                              <Avatar
                                                sx={{ borderRadius: "5px" }}
                                                alt="User Image"
                                                src={
                                                  s3baseUrl +
                                                  exerData?.exercise?.image
                                                    ?.thumbnail_3
                                                }
                                              />
                                            )}
                                            <div className="label-text ms-1">
                                              {exerData?.exercise?.title
                                                ? exerData?.exercise?.title
                                                : ""}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="exercise-action">
                                          <div style={{ fontSize: "16px" }}>
                                            {exerData?.exercise ? (
                                              <div>
                                                <InfoIcon
                                                  onClick={() =>
                                                    handleClickOpen(
                                                      exerData?.exercise?._id,
                                                    )
                                                  }
                                                  className="d-block"
                                                  fontSize="14px"
                                                  sx={{
                                                    opacity: 0.5,
                                                    cursor: "pointer",
                                                  }}
                                                />
                                                <EditIcon
                                                  onClick={() =>
                                                    handleSupersetExerciseList(
                                                      mainindex,
                                                      exerIndex,
                                                    )
                                                  }
                                                  fontSize="12px"
                                                  sx={{
                                                    opacity: 0.5,
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              </div>
                                            ) : (
                                              <AddIcon
                                                onClick={() =>
                                                  handleSupersetExerciseList(
                                                    mainindex,
                                                    exerIndex,
                                                  )
                                                }
                                                sx={{
                                                  opacity: 0.5,
                                                  cursor: "pointer",
                                                }}
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <Button
                                      sx={{ textTransform: "inherit" }}
                                      size="small"
                                      color="primary"
                                      variant="contained"
                                      className="d-flex align-items-center ms-2 small-contained-dialog-button"
                                      onClick={() => {
                                        handleArrowSuperSet(
                                          !exerData?.open ? true : false,
                                          mainindex,
                                          exerIndex,
                                        );
                                      }}
                                    >
                                      {!exerData?.open ? (
                                        <KeyboardArrowDownIcon
                                          className="bounce"
                                          sx={{
                                            cursor: "pointer",
                                            fontSize: "20px",
                                          }}
                                        />
                                      ) : (
                                        <KeyboardArrowUpIcon
                                          sx={{
                                            cursor: "pointer",
                                            fontSize: "20px",
                                          }}
                                        />
                                      )}

                                      <Typography
                                        variant="body2"
                                        sx={{
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        {` Sets ${exerData?.set?.length}`}
                                      </Typography>
                                    </Button>
                                  </div>

                                  <div
                                    className={`col-sm-12 ${"col-md-5"} col-lg-6 p-0 mt-2 mt-md-0 mt-lg-0 d-flex align-items-center justify-content-start `}
                                  >
                                    <div className="d-flex align-items-center mx-1">
                                      {exerData?.exercise && (
                                        <Button
                                          sx={{ textTransform: "inherit" }}
                                          size="small"
                                          color="primary"
                                          variant="contained"
                                          className="d-flex align-items-center ms-2 small-contained-dialog-button"
                                          onClick={() => {
                                            handleHistorySupersetOpen(
                                              exerData,
                                              mainindex,
                                              exerIndex,
                                            );
                                          }}
                                        >
                                          <Icon
                                            icon="fa-solid:history"
                                            fontSize="10px"
                                          />
                                          <Typography
                                            variant="body2"
                                            sx={{ ml: 0.5 }}
                                          >
                                            {`History`}
                                          </Typography>
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {exerData?.open && (
                                  <>
                                    {exerData.description && (
                                      <div className="col-12 mt-3 custom_description">
                                        <div className="custom_description_title">
                                          Instructions
                                        </div>
                                        <div className="custom_description_text">
                                          {isExpanded
                                            ? exerData.description
                                            : `${exerData.description.substring(
                                                0,
                                                maxLength,
                                              )}`}
                                          {exerData.description.length >
                                            maxLength && (
                                            <span
                                              className="toggle-text"
                                              style={{
                                                color:
                                                  "var(--portal-theme-primary)",
                                                cursor: "pointer",
                                                marginLeft: "5px",
                                              }}
                                              onClick={toggleExpand}
                                            >
                                              {isExpanded
                                                ? "See Less"
                                                : "See More"}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </>
                                )}
                                {exerData?.open &&
                                  exerData?.set?.map((item, setIndex) => (
                                    <div className="d-flex align-items-center my-3 workout-card-inset">
                                      <div className="d-flex align-items-center w-100">
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            padding: "25px 4px",
                                            color: "inherit",
                                            backgroundColor: "#edeff1",
                                            height: "100%",
                                            width: "15px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            borderRadius: "7px",
                                          }}
                                        >
                                          {setIndex + 1}
                                        </Typography>
                                        <CloseIcon sx={{ opacity: 0.3 }} />
                                        <div className="row w-100">
                                          {(exerData.parameters.includes(
                                            "Pace",
                                          ) ||
                                            exerData.parameters.includes(
                                              "Vdot",
                                            )) && (
                                            <>
                                              <div
                                                className={`col-12 col-md-3 col-lg-2 pe-0 py-2`}
                                              >
                                                <FormControl
                                                  readOnly={true}
                                                  fullWidth
                                                >
                                                  <InputLabel
                                                    className="set-Type-lable"
                                                    sx={{
                                                      fontSize: "14px",
                                                    }}
                                                    id="demo-simple-select-label"
                                                  >
                                                    Type
                                                  </InputLabel>

                                                  <Select
                                                    className="set-Type-value"
                                                    id="select-option"
                                                    variant="outlined"
                                                    size="small"
                                                    name="race_type"
                                                    value={item?.race_type}
                                                    label="Type"
                                                    readOnly={true}
                                                    inputProps={{
                                                      style: {
                                                        padding: 0,
                                                      },
                                                      readOnly: true,
                                                    }}
                                                    onChange={(e) => {
                                                      handleChangeSuperSet(
                                                        e,
                                                        mainindex,
                                                        exerIndex,
                                                        setIndex,
                                                      );
                                                    }}
                                                    sx={{
                                                      width: "100%",
                                                      fontSize: "13px",
                                                      "& .MuiOutlinedInput-input":
                                                        {
                                                          paddingLeft: 1,
                                                          paddingRight:
                                                            "16px !important",
                                                        },
                                                      "& input": {
                                                        textAlign: "center",
                                                        padding: "0px",
                                                      },
                                                    }}
                                                  >
                                                    <MenuItem value="el">
                                                      Easy/Long
                                                    </MenuItem>
                                                    <MenuItem value="c">
                                                      Compromised
                                                    </MenuItem>

                                                    <MenuItem value="i">
                                                      Interval
                                                    </MenuItem>
                                                    <MenuItem value="r">
                                                      Repitition
                                                    </MenuItem>
                                                  </Select>
                                                </FormControl>
                                              </div>
                                              <div
                                                className={`col-12 col-md-3 col-lg-2 pe-0 py-2`}
                                              >
                                                <TextField
                                                  sx={{
                                                    borderRadius: "5px",
                                                    paddingRight: 0,
                                                    width: "100%",
                                                  }}
                                                  size="small"
                                                  id="custom-input"
                                                  variant="outlined"
                                                  placeholder={"Distance"}
                                                  name="distance"
                                                  label="Distance"
                                                  value={item?.distance}
                                                  onChange={(e) => {
                                                    handleChangeSuperSet(
                                                      e,
                                                      mainindex,
                                                      exerIndex,
                                                      setIndex,
                                                    );
                                                  }}
                                                  readOnly
                                                  type="number"
                                                  InputLabelProps={{
                                                    shrink: true,
                                                    className:
                                                      "textfiels-input-label",
                                                    style: {
                                                      fontSize: "14px",
                                                    },
                                                  }}
                                                  InputProps={{
                                                    className:
                                                      "textfiels-input-value",
                                                    style: {
                                                      fontSize: "13px",
                                                      paddingRight: 0,
                                                    },
                                                    readOnly: true,
                                                    endAdornment: (
                                                      <InputAdornment position="end">
                                                        <Select
                                                          id="select-option"
                                                          variant="outlined"
                                                          size="small"
                                                          name="distanceType"
                                                          value={
                                                            item?.distanceType
                                                          }
                                                          label="Weight Type"
                                                          onChange={(e) => {
                                                            handleChangeSuperSet(
                                                              e,
                                                              mainindex,
                                                              exerIndex,
                                                              setIndex,
                                                            );
                                                          }}
                                                          readOnly={true}
                                                          sx={{
                                                            "& legend": {
                                                              display: "none",
                                                            },
                                                            "& fieldset": {
                                                              top: 0,
                                                            },
                                                            fontSize: "13px",
                                                            border: "none",
                                                            "& fieldset": {
                                                              border: "none",
                                                            },
                                                          }}
                                                        >
                                                          <MenuItem value="m">
                                                            Meter
                                                          </MenuItem>
                                                          <MenuItem value="km">
                                                            KM
                                                          </MenuItem>
                                                          <MenuItem value="mi">
                                                            Mile
                                                          </MenuItem>
                                                        </Select>
                                                      </InputAdornment>
                                                    ),
                                                  }}
                                                />
                                              </div>
                                              <div
                                                className={`col-12 col-md-2 col-lg-2 pe-0 py-2`}
                                              >
                                                <TextField
                                                  id="outlined-basic"
                                                  variant="outlined"
                                                  label={getPaceTextinPaces(
                                                    item?.distanceType,
                                                  )}
                                                  InputLabelProps={{
                                                    className:
                                                      "textfiels-input-label",
                                                    shrink: true,
                                                    style: {
                                                      fontSize: "14px",
                                                    },
                                                  }}
                                                  InputProps={{
                                                    className:
                                                      "textfiels-input-value",
                                                    style: {
                                                      fontSize: "13px",
                                                      paddingLeft: "0px",
                                                      paddingRight: "0px",

                                                      justifyContent: "center",
                                                    },
                                                    readOnly: true,
                                                    endAdornment: (
                                                      <InputAdornment
                                                        position="end"
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <TextField
                                                          id="outlined-basic-minutes"
                                                          type="number"
                                                          size="small"
                                                          placeholder="Min"
                                                          name="pace"
                                                          value={formatWithLeadingZeros(
                                                            Math.floor(
                                                              item?.pace / 60,
                                                            ),
                                                          )}
                                                          onChange={(e) =>
                                                            handleMinutesChangeSets(
                                                              e,
                                                              mainindex,
                                                              exerIndex,
                                                              setIndex,
                                                            )
                                                          }
                                                          InputProps={{
                                                            className:
                                                              "textfiels-input-value",
                                                            style: {
                                                              fontSize: "14px",
                                                            },
                                                            readOnly: true,
                                                          }}
                                                          sx={{
                                                            "& fieldset": {
                                                              border: "none",
                                                            },
                                                            "& input": {
                                                              textAlign:
                                                                "center",
                                                              padding: "0px",
                                                            },
                                                            width: "100%",
                                                          }}
                                                        />
                                                        <div className="fs-6 fw-semibold ms-1 ">
                                                          :
                                                        </div>

                                                        <TextField
                                                          id="outlined-basic-seconds"
                                                          type="number"
                                                          size="small"
                                                          placeholder="Sec"
                                                          name="pace"
                                                          value={formatWithLeadingZeros(
                                                            item?.pace % 60,
                                                          )}
                                                          onChange={(e) =>
                                                            handleSecondsChangeSets(
                                                              e,
                                                              mainindex,
                                                              exerIndex,
                                                              setIndex,
                                                            )
                                                          }
                                                          InputProps={{
                                                            className:
                                                              "textfiels-input-value",
                                                            style: {
                                                              fontSize: "14px",
                                                            },
                                                            readOnly: true,
                                                          }}
                                                          sx={{
                                                            "& fieldset": {
                                                              border: "none",
                                                            },
                                                            "& input": {
                                                              textAlign:
                                                                "center",
                                                              padding: "0px",
                                                            },
                                                            width: "100%",
                                                          }}
                                                        />
                                                      </InputAdornment>
                                                    ),
                                                  }}
                                                  sx={{
                                                    borderRadius: "5px",
                                                    fontSize: "13px",
                                                    "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                                      {
                                                        width: "0px !important",
                                                        padding:
                                                          "9px 0px !important",
                                                      },
                                                    "& .css-1nuss9t": {
                                                      width: "0px !important",
                                                      padding:
                                                        "9px 0px !important",
                                                    },
                                                    width: "100%",
                                                  }}
                                                />
                                              </div>

                                              <div
                                                style={{
                                                  position: "absolute",
                                                  bottom: "4px",
                                                  left: "5px",
                                                }}
                                              >
                                                <Typography
                                                  variant="subtitle2"
                                                  sx={{
                                                    opacity: 0.6,
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                  }}
                                                >{` @ Speed ${getKmhrForPace(
                                                  item?.distance,
                                                  item?.pace,
                                                  item?.distanceType,
                                                )} km/hr or ${getMihrForPace(
                                                  item?.distance,
                                                  item?.pace,
                                                  item?.distanceType,
                                                )} mi/hr`}</Typography>
                                              </div>
                                            </>
                                          )}
                                          {(exerData.parameters.includes(
                                            "Duration/Pace",
                                          ) ||
                                            exerData.parameters.includes(
                                              "Time",
                                            )) && (
                                            <div
                                              className={`col-12 col-md-3 col-lg-2 pe-0 py-2`}
                                            >
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="0"
                                                type="number"
                                                value={item?.time}
                                                name="time"
                                                onChange={(e) => {
                                                  handleChangeSuperSet(
                                                    e,
                                                    mainindex,
                                                    exerIndex,
                                                    setIndex,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                label={
                                                  exerData.parameters.includes(
                                                    "Duration/Pace",
                                                  )
                                                    ? "Duration/Pace"
                                                    : "Time"
                                                }
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="timeType"
                                                        value={item?.timeType}
                                                        label="Weight Type"
                                                        inputProps={{
                                                          style: {
                                                            padding: 0,
                                                          },
                                                        }}
                                                        onChange={(e) => {
                                                          handleChangeSuperSet(
                                                            e,
                                                            mainindex,
                                                            exerIndex,
                                                            setIndex,
                                                          );
                                                        }}
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                          "& .MuiOutlinedInput-input":
                                                            {
                                                              padding: 0,
                                                            },
                                                        }}
                                                      >
                                                        <MenuItem value="sec">
                                                          sec
                                                        </MenuItem>
                                                        <MenuItem value="min">
                                                          min
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Reps",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="Reps"
                                                type="number"
                                                label="Reps"
                                                value={item?.reps}
                                                name="reps"
                                                onChange={(e) => {
                                                  handleChangeSuperSet(
                                                    e,
                                                    mainindex,
                                                    exerIndex,
                                                    setIndex,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Watts",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="Watts"
                                                type="number"
                                                label="Watts"
                                                value={item?.watts}
                                                name="watts"
                                                onChange={(e) => {
                                                  handleChangeSuperSet(
                                                    e,
                                                    mainindex,
                                                    exerIndex,
                                                    setIndex,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Max_Reps",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="Max Reps"
                                                type="number"
                                                label="Max Reps"
                                                value={item?.maxReps}
                                                name="maxReps"
                                                onChange={(e) => {
                                                  handleChangeSuperSet(
                                                    e,
                                                    mainindex,
                                                    exerIndex,
                                                    setIndex,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Height",
                                          ) && (
                                            <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="0"
                                                type="number"
                                                value={item?.height}
                                                name="height"
                                                onChange={(e) => {
                                                  handleChangeSuperSet(
                                                    e,
                                                    mainindex,
                                                    exerIndex,
                                                    setIndex,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                label="Height"
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="height_unit"
                                                        value={
                                                          item?.height_unit
                                                        }
                                                        label="Height Type"
                                                        inputProps={{
                                                          style: {
                                                            padding: 0,
                                                          },
                                                        }}
                                                        onChange={(e) => {
                                                          handleChangeSuperSet(
                                                            e,
                                                            mainindex,
                                                            exerIndex,
                                                            setIndex,
                                                          );
                                                        }}
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                          "& .MuiOutlinedInput-input":
                                                            {
                                                              padding: 0,
                                                            },
                                                        }}
                                                      >
                                                        <MenuItem value="cm">
                                                          Cm
                                                        </MenuItem>
                                                        <MenuItem value="ft">
                                                          Feet
                                                        </MenuItem>
                                                        <MenuItem value="inch">
                                                          Inch
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Weight",
                                          ) && (
                                            <div className="col-12 col-md-4 col-lg-2 pe-0 py-2">
                                              <TextField
                                                sx={{
                                                  borderRadius: "5px",
                                                  paddingRight: 0,
                                                  width: "100%",
                                                }}
                                                size="small"
                                                id="custom-input"
                                                variant="outlined"
                                                placeholder="Weight"
                                                name="weight"
                                                label="Weight"
                                                value={item.weight}
                                                onChange={(e) => {
                                                  handleChangeSuperSet(
                                                    e,
                                                    mainindex,
                                                    exerIndex,
                                                    setIndex,
                                                  );
                                                }}
                                                type="number"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="weightType"
                                                        value={item?.weightType}
                                                        label="Weight Type"
                                                        onChange={(e) => {
                                                          handleChangeSuperSet(
                                                            e,
                                                            mainindex,
                                                            exerIndex,
                                                            setIndex,
                                                          );
                                                        }}
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                          "& .MuiOutlinedInput-input":
                                                            {
                                                              padding: 0,
                                                            },
                                                        }}
                                                      >
                                                        <MenuItem value="1rm">
                                                          % 1RM
                                                        </MenuItem>
                                                        <MenuItem value="body_weight">
                                                          % BW
                                                        </MenuItem>
                                                        <MenuItem value="kg">
                                                          KG
                                                        </MenuItem>
                                                        <MenuItem value="lb">
                                                          Pound
                                                        </MenuItem>
                                                        <MenuItem value="poods">
                                                          Poods
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Distance/Calories",
                                          ) && (
                                            <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                                              <TextField
                                                sx={{
                                                  borderRadius: "5px",
                                                  paddingRight: 0,
                                                  width: "100%",
                                                }}
                                                size="small"
                                                id="custom-input"
                                                variant="outlined"
                                                placeholder={
                                                  item?.distanceType ==
                                                  "calories"
                                                    ? "Calories"
                                                    : "Distance"
                                                }
                                                name="distance"
                                                label="Distance/Calories"
                                                value={item?.distance}
                                                onChange={(e) => {
                                                  handleChangeSuperSet(
                                                    e,
                                                    mainindex,
                                                    exerIndex,
                                                    setIndex,
                                                  );
                                                }}
                                                type="number"
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="distanceType"
                                                        value={
                                                          item?.distanceType
                                                        }
                                                        label="Weight Type"
                                                        onChange={(e) => {
                                                          handleChangeSuperSet(
                                                            e,
                                                            mainindex,
                                                            exerIndex,
                                                            setIndex,
                                                          );
                                                        }}
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                          "& .MuiOutlinedInput-input":
                                                            {
                                                              padding: 0,
                                                            },
                                                        }}
                                                      >
                                                        <MenuItem value="m">
                                                          Meter
                                                        </MenuItem>
                                                        <MenuItem value="km">
                                                          KM
                                                        </MenuItem>
                                                        <MenuItem value="mi">
                                                          Mile
                                                        </MenuItem>
                                                        <MenuItem value="calories">
                                                          Calories
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "%MHR",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="%MHR"
                                                type="number"
                                                label="%MHR"
                                                value={item?.mhr}
                                                name="mhr"
                                                onChange={(e) => {
                                                  handleChangeSuperSetTempo(
                                                    e,
                                                    mainindex,
                                                    exerIndex,
                                                    setIndex,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: "8px 7px",
                                                  },
                                                }}
                                              />
                                            </div>
                                          )}{" "}
                                          {exerData.parameters.includes(
                                            "RPE",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="RPE"
                                                label="RPE"
                                                value={item?.RPE}
                                                name="RPE"
                                                onChange={(e) => {
                                                  handleChangeSuperSet(
                                                    e,
                                                    mainindex,
                                                    exerIndex,
                                                    setIndex,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: "8px 7px",
                                                  },
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Tempo",
                                          ) && (
                                            <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="Tempo"
                                                type="number"
                                                label="Tempo"
                                                value={item?.tempo}
                                                name="tempo"
                                                onChange={(e) => {
                                                  handleChangeSuperSetTempo(
                                                    e,
                                                    mainindex,
                                                    exerIndex,
                                                    setIndex,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                  },
                                                  readOnly: true,
                                                }}
                                                sx={{
                                                  borderRadius: "5px",

                                                  fontSize: "13px",
                                                  width: "100%",
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: "8px 7px",
                                                  },
                                                }}
                                              />
                                            </div>
                                          )}
                                          {exerData.parameters.includes(
                                            "Rest",
                                          ) && (
                                            <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                                              <TextField
                                                id="outlined-basic"
                                                size="small"
                                                variant="outlined"
                                                placeholder="0"
                                                type="number"
                                                value={item?.rest}
                                                name="rest"
                                                onChange={(e) => {
                                                  handleChangeSuperSet(
                                                    e,
                                                    mainindex,
                                                    exerIndex,
                                                    setIndex,
                                                  );
                                                }}
                                                InputLabelProps={{
                                                  className:
                                                    "textfiels-input-label",
                                                  shrink: true,
                                                  style: {
                                                    fontSize: "14px",
                                                  },
                                                }}
                                                label="Rest"
                                                InputProps={{
                                                  className:
                                                    "textfiels-input-value",
                                                  style: {
                                                    fontSize: "13px",
                                                    paddingRight: 0,
                                                  },
                                                  endAdornment: (
                                                    <InputAdornment position="end">
                                                      <Select
                                                        id="select-option"
                                                        variant="outlined"
                                                        size="small"
                                                        name="restType"
                                                        value={item?.restType}
                                                        label="Weight Type"
                                                        inputProps={{
                                                          style: {
                                                            padding: 0,
                                                          },
                                                        }}
                                                        onChange={(e) => {
                                                          handleChangeSuperSet(
                                                            e,
                                                            mainindex,
                                                            exerIndex,
                                                            setIndex,
                                                          );
                                                        }}
                                                        sx={{
                                                          "& legend": {
                                                            display: "none",
                                                          },
                                                          "& fieldset": {
                                                            top: 0,
                                                          },
                                                          fontSize: "13px",
                                                          border: "none",
                                                          "& fieldset": {
                                                            border: "none",
                                                          },
                                                          "& .MuiOutlinedInput-input":
                                                            {
                                                              padding: 0,
                                                            },
                                                        }}
                                                      >
                                                        <MenuItem value="sec">
                                                          sec
                                                        </MenuItem>
                                                        <MenuItem value="min">
                                                          min
                                                        </MenuItem>
                                                      </Select>
                                                    </InputAdornment>
                                                  ),
                                                }}
                                                sx={{
                                                  borderRadius: "5px",
                                                  fontSize: "13px",
                                                  width: "100%",
                                                }}
                                              />
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                {exerData?.open && (
                                  <>
                                    <div className="d-flex justify-content-end mt-3">
                                      {" "}
                                      <FormGroup>
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                              sx={{ p: "3px" }}
                                              checked={exerData.is_completed}
                                              onChange={(e) =>
                                                handleChangeCompleteSet(
                                                  e,
                                                  mainindex,
                                                  exerIndex,
                                                )
                                              }
                                            />
                                          }
                                          label="Mark as Complete"
                                        />
                                      </FormGroup>
                                    </div>
                                  </>
                                )}
                                {exerData?.open && (
                                  <div className="row mt-3 d-flex justify-content-center">
                                    <div className="col-md-2 col-lg-1 col-3">
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();

                                          handleArrowSuperSet(
                                            false,
                                            mainindex,
                                            exerIndex,
                                          );
                                        }}
                                        className="w-100 small-contained-set-button"
                                      >
                                        <KeyboardArrowUpIcon
                                          sx={{
                                            cursor: "pointer",
                                            opacity: 0.5,
                                            fontSize: "20px",
                                          }}
                                          onClick={() => {
                                            handleArrowSuperSet(
                                              false,
                                              mainindex,
                                              exerIndex,
                                            );
                                          }}
                                        />
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </Box>
                            </div>
                          ))}
                        </div>
                      </Box>
                    </div>
                  </>
                ) : (
                  <div
                    className="d-flex my-2 workout-set-card w-100"
                    style={{
                      position: "relative",
                      width: "100%",
                      overflow: "hidden",
                    }}
                    onMouseEnter={() => handleMouseLeave()}
                  >
                    <Box
                      sx={{
                        width: "100%",
                      }}
                      onMouseEnter={() => handleMouseLeave()}
                    >
                      <div
                        className="row  "
                        onMouseEnter={() => handleMouseLeave()}
                      >
                        <div
                          className={`col-sm-12 ${"col-md-7"} col-lg-6 d-flex align-items-center p-0 mt-2 mt-md-0 mt-lg-0`}
                        >
                          {data?.is_modified && (
                            <span
                              style={{
                                position: "absolute",
                                top: "10px",
                                justifyContent: "center",
                                zIndex: "1",
                                left: "-18px",
                                transform: "rotate(-53deg)",
                              }}
                            >
                              <Chip
                                label={"Modified"}
                                variant="contained"
                                color={"error"}
                                sx={{
                                  fontSize: "10px",
                                  height: "auto",
                                  width: "auto",
                                }}
                              />
                            </span>
                          )}
                          <div className="exercise-label-box">
                            <span className="outer-label">Exercise</span>
                            <div className="d-flex align-items-center justify-content-between">
                              <div
                                className="exercise-label w-100"
                                onClick={() => {
                                  data.parameters.includes("Vdot")
                                    ? ""
                                    : handleExerciseList(mainindex);
                                }}
                              >
                                <div className="d-flex align-items-center">
                                  {data?.exercise?.image?.thumbnail_3 && (
                                    <Avatar
                                      sx={{ borderRadius: "5px" }}
                                      alt="User Image"
                                      src={
                                        s3baseUrl +
                                        data?.exercise?.image?.thumbnail_3
                                      }
                                    />
                                  )}
                                  <div className="label-text ms-1">
                                    {data?.exercise?.title
                                      ? data?.exercise?.title
                                      : ""}
                                  </div>
                                </div>
                              </div>
                              <div className="exercise-action">
                                <div style={{ fontSize: "16px" }}>
                                  {data?.exercise ? (
                                    <div>
                                      <InfoIcon
                                        onClick={() =>
                                          handleClickOpen(data?.exercise?._id)
                                        }
                                        className="d-block"
                                        fontSize="14px"
                                        sx={{
                                          opacity: 0.5,
                                          cursor: "pointer",
                                        }}
                                      />
                                      {!data.parameters.includes("Vdot") && (
                                        <EditIcon
                                          onClick={() =>
                                            handleExerciseList(mainindex)
                                          }
                                          fontSize="12px"
                                          sx={{
                                            opacity: 0.5,
                                            cursor: "pointer",
                                          }}
                                        />
                                      )}
                                    </div>
                                  ) : (
                                    <AddIcon
                                      onClick={() =>
                                        handleExerciseList(mainindex)
                                      }
                                      sx={{ opacity: 0.5, cursor: "pointer" }}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <Button
                            sx={{ textTransform: "inherit" }}
                            size="small"
                            color="primary"
                            variant="contained"
                            className="d-flex align-items-center ms-2 small-contained-dialog-button"
                            onClick={() => {
                              handleArrow(
                                !data?.open ? true : false,
                                mainindex,
                              );
                            }}
                          >
                            {!data?.open ? (
                              <KeyboardArrowDownIcon
                                className="bounce"
                                sx={{
                                  cursor: "pointer",
                                  fontSize: "20px",
                                }}
                              />
                            ) : (
                              <KeyboardArrowUpIcon
                                sx={{
                                  cursor: "pointer",
                                  // opacity: 0.5,
                                  fontSize: "20px",
                                }}
                              />
                            )}

                            <Typography
                              variant="body2"
                              sx={{
                                // opacity: 0.6,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {` Sets ${data?.set?.length}`}
                            </Typography>
                          </Button>
                        </div>

                        <div
                          className={`col-sm-12 ${"col-md-5"} col-lg-6 p-0 mt-2 mt-md-0 mt-lg-0 d-flex align-items-center justify-content-start `}
                        >
                          {data?.exercise && (
                            <Button
                              sx={{ textTransform: "inherit" }}
                              size="small"
                              color="primary"
                              variant="contained"
                              className="d-flex align-items-center ms-2 small-contained-dialog-button"
                              onClick={() => {
                                handleHistoryOpen(data, mainindex);
                              }}
                            >
                              <Icon icon="fa-solid:history" fontSize="10px" />
                              <Typography variant="body2" sx={{ ml: 0.5 }}>
                                {`History`}
                              </Typography>
                            </Button>
                          )}
                        </div>
                      </div>
                      {data?.open && (
                        <>
                          {data.description && (
                            <div className="col-12 mt-3 custom_description">
                              <div className="custom_description_title">
                                Instructions
                              </div>
                              <div className="custom_description_text">
                                {isExpanded
                                  ? data.description
                                  : `${data.description.substring(
                                      0,
                                      maxLength,
                                    )}`}
                                {data.description.length > maxLength && (
                                  <span
                                    className="toggle-text"
                                    style={{
                                      color: "var(--portal-theme-primary)",
                                      cursor: "pointer",
                                      marginLeft: "5px",
                                    }}
                                    onClick={toggleExpand}
                                  >
                                    {isExpanded ? "See Less" : "See More"}
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                        </>
                      )}
                      {data?.open &&
                        data?.set?.map((item, index1) => (
                          <div
                            className="d-flex align-items-center my-3 workout-card-inset"
                            onMouseEnter={() =>
                              handleMouseEnter(index1, mainindex)
                            }

                            // onMouseLeave={() => handleMouseLeave()}
                          >
                            <div>
                              {isHovered === index1 &&
                                !data.parameters.includes("Vdot") &&
                                isHoveredExercise == mainindex && (
                                  <div
                                    className="icon-calendar-workout"
                                    onMouseEnter={() =>
                                      handleMouseEnter(index1, mainindex)
                                    }
                                  >
                                    <Tooltip title="Add Set">
                                      <AddIcon
                                        className="add-icon-calendar-workout me-1"
                                        onMouseEnter={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() =>
                                          handleAddSet(mainindex, index1)
                                        }
                                      />
                                    </Tooltip>
                                    <Tooltip
                                      title={`${
                                        data?.set.length > 1
                                          ? "Delete Set"
                                          : "Can't be Deleted"
                                      }`}
                                    >
                                      <DeleteIcon
                                        onMouseEnter={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        className={`${
                                          data?.set.length > 1
                                            ? "del-icon-calendar-workout-working"
                                            : "del-icon-calendar-workout-notwork"
                                        }`}
                                        onClick={
                                          data?.set.length > 1
                                            ? () =>
                                                handleDeleteSet(
                                                  mainindex,
                                                  index1,
                                                )
                                            : () => {}
                                        }
                                      />
                                    </Tooltip>
                                  </div>
                                )}
                            </div>
                            {data.parameters.includes("Vdot") &&
                            item?.vdot &&
                            !item?.pace &&
                            !item?.paceUP ? (
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                justifyContent="start"
                                sx={{
                                  padding: data.parameters.includes("Vdot")
                                    ? "9px 0px"
                                    : "",
                                  overflowX: "auto", // Add this line to enable horizontal scrolling
                                  "&::-webkit-scrollbar": {
                                    height: "5px", // Customize the scrollbar height
                                  },
                                  "&::-webkit-scrollbar-thumb": {
                                    backgroundColor: "#888", // Customize the scrollbar thumb color
                                    borderRadius: "5px", // Optional: Customize the thumb border radius
                                  },
                                  "&::-webkit-scrollbar-track": {
                                    backgroundColor: "#f1f1f1", // Optional: Customize the track color
                                  },
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    opacity: 0.6,
                                    fontWeight: "600",
                                    fontSize: "12px",
                                  }}
                                >
                                  Oops! this exercise not suitable for you.
                                  Please contact your coach.
                                </Typography>
                              </Stack>
                            ) : data.parameters.includes("Vdot") &&
                              !item?.vdot ? (
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                justifyContent="start"
                                sx={{
                                  padding: data.parameters.includes("Vdot")
                                    ? "9px 0px"
                                    : "",
                                  overflowX: "auto", // Add this line to enable horizontal scrolling
                                  "&::-webkit-scrollbar": {
                                    height: "5px", // Customize the scrollbar height
                                  },
                                  "&::-webkit-scrollbar-thumb": {
                                    backgroundColor: "#888", // Customize the scrollbar thumb color
                                    borderRadius: "5px", // Optional: Customize the thumb border radius
                                  },
                                  "&::-webkit-scrollbar-track": {
                                    backgroundColor: "#f1f1f1", // Optional: Customize the track color
                                  },
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    opacity: 0.6,
                                    fontWeight: "600",
                                    fontSize: "12px",
                                  }}
                                >
                                  Auto Pacer is not calculated. Please{" "}
                                  <Link
                                    component={RouterLink}
                                    variant="subtitle2"
                                    to={`/edit-profile`}
                                  >
                                    Click here
                                  </Link>{" "}
                                  to calculate it.
                                </Typography>
                              </Stack>
                            ) : (
                              <div className="d-flex align-items-center w-100">
                                {!data.parameters.includes("Vdot") && (
                                  <div className="d-flex align-items-center">
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        padding: "25px 4px",
                                        color: "inherit",
                                        backgroundColor: "#edeff1",
                                        height: "100%",
                                        width: "15px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "7px",
                                      }}
                                    >
                                      {index1 + 1}
                                    </Typography>

                                    <CloseIcon sx={{ opacity: 0.3 }} />
                                  </div>
                                )}
                                <div className="row w-100">
                                  {data.parameters.includes("Vdot") && (
                                    <>
                                      <div
                                        className={`col-12 col-md-5 ${
                                          item?.race_type == "el"
                                            ? "col-lg-3"
                                            : "col-lg-3"
                                        } pe-0 py-2`}
                                      >
                                        <TextField
                                          id="outlined-basic"
                                          variant="outlined"
                                          label="Type"
                                          InputLabelProps={{
                                            className: "textfiels-input-label",
                                            shrink: true,
                                            style: { fontSize: "14px" },
                                          }}
                                          InputProps={{
                                            className: "textfiels-input-value",
                                            style: {
                                              fontSize: "13px",
                                              paddingLeft: "0px",
                                              paddingRight: "0px",

                                              justifyContent: "center",
                                            },
                                            readOnly: true,
                                            endAdornment: (
                                              <InputAdornment
                                                position="end"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <Select
                                                  id="select-option"
                                                  variant="outlined"
                                                  size="small"
                                                  name="race_type"
                                                  value={item?.race_type}
                                                  label="Weight Type"
                                                  readOnly={true}
                                                  inputProps={{
                                                    style: {
                                                      padding: 0,
                                                    },
                                                    readOnly: true,
                                                  }}
                                                  onChange={(e) => {
                                                    handleChangeVdotDistance(
                                                      e,
                                                      mainindex,
                                                      index1,
                                                    );
                                                  }}
                                                  sx={{
                                                    "& legend": {
                                                      display: "none",
                                                    },
                                                    "& fieldset": {
                                                      top: 0,
                                                    },
                                                    fontSize: "13px",
                                                    border: "none",
                                                    "& fieldset": {
                                                      border: "none",
                                                    },
                                                    "& .MuiOutlinedInput-input":
                                                      {
                                                        padding: 0,
                                                      },
                                                  }}
                                                >
                                                  <MenuItem value="el">
                                                    Easy/Long
                                                  </MenuItem>
                                                  <MenuItem value="c">
                                                    Compromised
                                                  </MenuItem>
                                                  <MenuItem value="t">
                                                    Threshold
                                                  </MenuItem>
                                                  <MenuItem value="i">
                                                    Interval
                                                  </MenuItem>
                                                  <MenuItem value="r">
                                                    Repitition
                                                  </MenuItem>
                                                </Select>

                                                <Select
                                                  id="select-option"
                                                  variant="outlined"
                                                  size="small"
                                                  name="pace_type"
                                                  value={item?.pace_type}
                                                  label="Weight Type"
                                                  readOnly={true}
                                                  inputProps={{
                                                    style: {
                                                      padding: 0,
                                                    },
                                                    readOnly: true,
                                                  }}
                                                  onChange={(e) => {
                                                    handleChangeVdotPaceType(
                                                      e,
                                                      mainindex,
                                                      index1,
                                                    );
                                                  }}
                                                  sx={{
                                                    "& legend": {
                                                      display: "none",
                                                    },
                                                    "& fieldset": {
                                                      top: 0,
                                                    },
                                                    fontSize: "13px",
                                                    border: "none",
                                                    "& fieldset": {
                                                      border: "none",
                                                    },
                                                    "& .MuiOutlinedInput-input":
                                                      {
                                                        padding: 0,
                                                      },
                                                  }}
                                                >
                                                  {item?.optionsType?.map(
                                                    (option) => {
                                                      return (
                                                        <MenuItem
                                                          key={option?.key}
                                                          value={option?.key}
                                                        >
                                                          {option?.title}
                                                        </MenuItem>
                                                      );
                                                    },
                                                  )}
                                                </Select>
                                              </InputAdornment>
                                            ),
                                          }}
                                          sx={{
                                            borderRadius: "5px",
                                            fontSize: "13px",
                                            "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                              {
                                                width: "0px !important",
                                                padding: "9px 0px !important",
                                              },
                                            "& .css-1nuss9t": {
                                              width: "0px !important",
                                              padding: "9px 0px !important",
                                            },

                                            width: "100%",
                                          }}
                                        />
                                      </div>
                                      {item?.race_type == "el" ? (
                                        <div
                                          className={`col-12 col-md-3 col-lg-2 pe-0 py-2`}
                                        >
                                          <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            label={getPaceText(item?.pace_type)}
                                            InputLabelProps={{
                                              className:
                                                "textfiels-input-label",
                                              shrink: true,
                                              style: { fontSize: "14px" },
                                            }}
                                            InputProps={{
                                              className:
                                                "textfiels-input-value",
                                              style: {
                                                fontSize: "13px",
                                                paddingLeft: "0px",
                                                paddingRight: "0px",

                                                justifyContent: "center",
                                              },

                                              readOnly: true,
                                              endAdornment: (
                                                <InputAdornment
                                                  position="end"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <TextField
                                                    id="outlined-basic-minutes"
                                                    type="number"
                                                    size="small"
                                                    placeholder="Min"
                                                    name="pace"
                                                    value={formatWithLeadingZeros(
                                                      Math.floor(
                                                        item?.pace / 60,
                                                      ),
                                                    )}
                                                    readOnly={true}
                                                    onChange={(e) =>
                                                      handleMinutesChange(
                                                        e,
                                                        mainindex,
                                                        index1,
                                                      )
                                                    }
                                                    InputProps={{
                                                      className:
                                                        "textfiels-input-value",
                                                      style: {
                                                        fontSize: "14px",
                                                      },
                                                      readOnly: true,
                                                    }}
                                                    sx={{
                                                      "& fieldset": {
                                                        border: "none",
                                                      },

                                                      "& input": {
                                                        textAlign: "center",
                                                        padding: "0px",
                                                      },
                                                      width: "100%",
                                                    }}
                                                  />
                                                  <div className="fs-6 fw-semibold ms-1 ">
                                                    :
                                                  </div>

                                                  <TextField
                                                    id="outlined-basic-seconds"
                                                    type="number"
                                                    size="small"
                                                    placeholder="Sec"
                                                    name="pace"
                                                    value={formatWithLeadingZeros(
                                                      item?.pace % 60,
                                                    )}
                                                    onChange={(e) =>
                                                      handleSecondsChange(
                                                        e,
                                                        mainindex,
                                                        index1,
                                                      )
                                                    }
                                                    InputProps={{
                                                      className:
                                                        "textfiels-input-value",
                                                      style: {
                                                        fontSize: "14px",
                                                      },
                                                      readOnly: true,
                                                    }}
                                                    sx={{
                                                      "& fieldset": {
                                                        border: "none",
                                                      },

                                                      "& input": {
                                                        textAlign: "center",
                                                        padding: "0px",
                                                      },
                                                      width: "100%",
                                                    }}
                                                  />
                                                  <div className="fs-6 fw-semibold ms-1 me-1 ">
                                                    -
                                                  </div>
                                                  <TextField
                                                    id="outlined-basic-minutes"
                                                    type="number"
                                                    size="small"
                                                    placeholder="Min"
                                                    name="paceUp"
                                                    value={formatWithLeadingZeros(
                                                      Math.floor(
                                                        item?.paceUp / 60,
                                                      ),
                                                    )}
                                                    onChange={(e) =>
                                                      handleMinutesChange(
                                                        e,
                                                        mainindex,
                                                        index1,
                                                      )
                                                    }
                                                    InputProps={{
                                                      className:
                                                        "textfiels-input-value",
                                                      style: {
                                                        fontSize: "14px",
                                                      },
                                                      readOnly: true,
                                                    }}
                                                    sx={{
                                                      "& fieldset": {
                                                        border: "none",
                                                      },

                                                      "& input": {
                                                        textAlign: "center",
                                                        padding: "0px",
                                                      },
                                                      width: "100%",
                                                    }}
                                                  />
                                                  <div className="fs-6 fw-semibold ms-1 ">
                                                    :
                                                  </div>

                                                  <TextField
                                                    id="outlined-basic-seconds"
                                                    type="number"
                                                    size="small"
                                                    placeholder="Sec"
                                                    name="paceUp"
                                                    value={formatWithLeadingZeros(
                                                      item?.paceUp % 60,
                                                    )}
                                                    onChange={(e) =>
                                                      handleSecondsChange(
                                                        e,
                                                        mainindex,
                                                        index1,
                                                      )
                                                    }
                                                    InputProps={{
                                                      className:
                                                        "textfiels-input-value",
                                                      style: {
                                                        fontSize: "14px",
                                                      },
                                                      readOnly: true,
                                                    }}
                                                    sx={{
                                                      "& fieldset": {
                                                        border: "none",
                                                      },

                                                      "& input": {
                                                        textAlign: "center",
                                                        padding: "0px",
                                                      },
                                                      width: "100%",
                                                      marginRight: 1,
                                                    }}
                                                  />
                                                </InputAdornment>
                                              ),
                                            }}
                                            sx={{
                                              borderRadius: "5px",
                                              fontSize: "13px",
                                              "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                                {
                                                  width: "0px !important",
                                                  padding: "9px 0px !important",
                                                },
                                              "& .css-1nuss9t": {
                                                width: "0px !important",
                                                padding: "9px 0px !important",
                                              },
                                              width: "100%",
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        <div
                                          className={`col-12 col-md-2 col-lg-1 pe-0 py-2`}
                                        >
                                          <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            label={getPaceText(item?.pace_type)}
                                            InputLabelProps={{
                                              className:
                                                "textfiels-input-label",
                                              shrink: true,
                                              style: { fontSize: "14px" },
                                            }}
                                            InputProps={{
                                              className:
                                                "textfiels-input-value",
                                              style: {
                                                fontSize: "13px",
                                                paddingLeft: "0px",
                                                paddingRight: "0px",

                                                justifyContent: "center",
                                              },
                                              readOnly: true,
                                              endAdornment: (
                                                <InputAdornment
                                                  position="end"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <TextField
                                                    id="outlined-basic-minutes"
                                                    type="number"
                                                    size="small"
                                                    placeholder="Min"
                                                    name="pace"
                                                    value={formatWithLeadingZeros(
                                                      Math.floor(
                                                        item?.pace / 60,
                                                      ),
                                                    )}
                                                    onChange={(e) =>
                                                      handleMinutesChange(
                                                        e,
                                                        mainindex,
                                                        index1,
                                                      )
                                                    }
                                                    InputProps={{
                                                      className:
                                                        "textfiels-input-value",
                                                      style: {
                                                        fontSize: "14px",
                                                      },
                                                      readOnly: true,
                                                    }}
                                                    sx={{
                                                      "& fieldset": {
                                                        border: "none",
                                                      },
                                                      "& input": {
                                                        textAlign: "center",
                                                        padding: "0px",
                                                      },
                                                      width: "100%",
                                                    }}
                                                  />
                                                  <div className="fs-6 fw-semibold ms-1 ">
                                                    :
                                                  </div>
                                                  <TextField
                                                    id="outlined-basic-seconds"
                                                    type="number"
                                                    size="small"
                                                    placeholder="Sec"
                                                    name="pace"
                                                    value={formatWithLeadingZeros(
                                                      item?.pace % 60,
                                                    )}
                                                    onChange={(e) =>
                                                      handleSecondsChange(
                                                        e,
                                                        mainindex,
                                                        index1,
                                                      )
                                                    }
                                                    InputProps={{
                                                      className:
                                                        "textfiels-input-value",
                                                      style: {
                                                        fontSize: "14px",
                                                      },
                                                      readOnly: true,
                                                    }}
                                                    sx={{
                                                      "& fieldset": {
                                                        border: "none",
                                                      },
                                                      "& input": {
                                                        textAlign: "center",
                                                        padding: "0px",
                                                      },
                                                      width: "100%",
                                                    }}
                                                  />
                                                </InputAdornment>
                                              ),
                                            }}
                                            sx={{
                                              borderRadius: "5px",
                                              fontSize: "13px",
                                              "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                                {
                                                  width: "0px !important",
                                                  padding: "9px 0px !important",
                                                },
                                              "& .css-1nuss9t": {
                                                width: "0px !important",
                                                padding: "9px 0px !important",
                                              },
                                              width: "100%",
                                            }}
                                          />
                                        </div>
                                      )}
                                    </>
                                  )}
                                  {data.parameters.includes("Pace") && (
                                    <>
                                      <div
                                        className={`col-12 col-md-3 ${
                                          item?.race_type == "t"
                                            ? "col-lg-3"
                                            : "col-lg-2"
                                        } pe-0 py-2`}
                                      >
                                        <FormControl
                                          fullWidth
                                          className="py-1"
                                          readOnly={true}
                                        >
                                          <InputLabel
                                            className="set-Type-lable"
                                            sx={{ fontSize: "14px" }}
                                            id="demo-simple-select-label"
                                          >
                                            Type
                                          </InputLabel>
                                          <Select
                                            className="set-Type-value"
                                            id="select-option"
                                            variant="outlined"
                                            size="small"
                                            name="race_type"
                                            value={item?.race_type}
                                            label="Type"
                                            readOnly
                                            inputProps={{
                                              style: {
                                                padding: 0,
                                              },
                                              readOnly: true,
                                            }}
                                            onChange={(e) => {
                                              handleChangeVdotDistance(
                                                e,
                                                mainindex,
                                                index1,
                                              );
                                            }}
                                            sx={{
                                              width: "100%",
                                              fontSize: "13px",

                                              "& .MuiOutlinedInput-input": {
                                                paddingLeft: 1,
                                                paddingRight: "16px !important",
                                              },
                                            }}
                                          >
                                            <MenuItem value="el">
                                              Easy/Long
                                            </MenuItem>
                                            <MenuItem value="c">
                                              Compromised
                                            </MenuItem>
                                            <MenuItem value="t">
                                              Threshold/Tempo
                                            </MenuItem>
                                            <MenuItem value="i">
                                              Interval
                                            </MenuItem>
                                            <MenuItem value="r">
                                              Repitition
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </div>
                                      <div
                                        className={`col-12 col-md-3 col-lg-2 pe-0 py-2`}
                                      >
                                        <TextField
                                          sx={{
                                            borderRadius: "5px",
                                            paddingRight: 0,
                                            width: "100%",
                                          }}
                                          size="small"
                                          id="custom-input"
                                          variant="outlined"
                                          onMouseLeave={() =>
                                            handleMouseEnter(index1, mainindex)
                                          }
                                          onClick={() => handleMouseLeave()}
                                          placeholder={"Distance"}
                                          name="distance"
                                          label="Distance"
                                          value={item?.distance}
                                          onChange={(e) => {
                                            handleChange(e, mainindex, index1);
                                          }}
                                          readOnly={true}
                                          type="number"
                                          InputLabelProps={{
                                            className: "textfiels-input-label",
                                            shrink: true,
                                            style: { fontSize: "14px" },
                                          }}
                                          InputProps={{
                                            className: "textfiels-input-value",
                                            style: {
                                              fontSize: "13px",
                                              paddingRight: 0,
                                            },
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <Select
                                                  id="select-option"
                                                  variant="outlined"
                                                  size="small"
                                                  name="distanceType"
                                                  value={item?.distanceType}
                                                  label="Weight Type"
                                                  onChange={(e) => {
                                                    handleChange(
                                                      e,
                                                      mainindex,
                                                      index1,
                                                    );
                                                  }}
                                                  onMouseLeave={() =>
                                                    handleMouseEnter(
                                                      index1,
                                                      mainindex,
                                                    )
                                                  }
                                                  onClick={() =>
                                                    handleMouseLeave()
                                                  }
                                                  sx={{
                                                    "& legend": {
                                                      display: "none",
                                                    },
                                                    "& fieldset": { top: 0 },
                                                    fontSize: "13px",
                                                    border: "none",
                                                    "& fieldset": {
                                                      border: "none",
                                                    },
                                                  }}
                                                >
                                                  <MenuItem value="m">
                                                    Meter
                                                  </MenuItem>
                                                  <MenuItem value="km">
                                                    KM
                                                  </MenuItem>
                                                  <MenuItem value="mi">
                                                    Mile
                                                  </MenuItem>
                                                </Select>
                                              </InputAdornment>
                                            ),
                                          }}
                                        />
                                      </div>
                                      <div
                                        className={`col-12 col-md-2 col-lg-2 pe-0 py-2`}
                                      >
                                        <TextField
                                          id="outlined-basic"
                                          variant="outlined"
                                          label={getPaceTextinPaces(
                                            item?.distanceType,
                                          )}
                                          InputLabelProps={{
                                            className: "textfiels-input-label",
                                            shrink: true,
                                            style: { fontSize: "14px" },
                                          }}
                                          InputProps={{
                                            className: "textfiels-input-value",
                                            style: {
                                              fontSize: "13px",
                                              paddingLeft: "0px",
                                              paddingRight: "0px",
                                              justifyContent: "center",
                                            },
                                            endAdornment: (
                                              <InputAdornment
                                                position="end"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <TextField
                                                  id="outlined-basic-minutes"
                                                  type="number"
                                                  size="small"
                                                  placeholder="Min"
                                                  name="pace"
                                                  value={formatWithLeadingZeros(
                                                    Math.floor(item?.pace / 60),
                                                  )}
                                                  onChange={(e) =>
                                                    handleMinutesChange(
                                                      e,
                                                      mainindex,
                                                      index1,
                                                    )
                                                  }
                                                  InputProps={{
                                                    className:
                                                      "textfiels-input-value",
                                                    style: {
                                                      fontSize: "14px",
                                                    },
                                                  }}
                                                  sx={{
                                                    "& fieldset": {
                                                      border: "none",
                                                    },
                                                    "& input": {
                                                      textAlign: "center",
                                                      padding: "0px",
                                                    },
                                                    width: "100%",
                                                  }}
                                                />
                                                <div className="fs-6 fw-semibold ms-1 ">
                                                  :
                                                </div>
                                                <TextField
                                                  id="outlined-basic-seconds"
                                                  type="number"
                                                  size="small"
                                                  placeholder="Sec"
                                                  name="pace"
                                                  value={formatWithLeadingZeros(
                                                    item?.pace % 60,
                                                  )}
                                                  onChange={(e) =>
                                                    handleSecondsChange(
                                                      e,
                                                      mainindex,
                                                      index1,
                                                    )
                                                  }
                                                  InputProps={{
                                                    className:
                                                      "textfiels-input-value",
                                                    style: {
                                                      fontSize: "14px",
                                                    },
                                                  }}
                                                  sx={{
                                                    "& fieldset": {
                                                      border: "none",
                                                    },
                                                    "& input": {
                                                      textAlign: "center",
                                                      padding: "0px",
                                                    },
                                                    width: "100%",
                                                  }}
                                                />
                                              </InputAdornment>
                                            ),
                                          }}
                                          sx={{
                                            borderRadius: "5px",
                                            fontSize: "13px",
                                            "& .css-e9crry-MuiInputBase-input-MuiOutlinedInput-input":
                                              {
                                                width: "0px !important",
                                                padding: "9px 0px !important",
                                              },
                                            "& .css-1nuss9t": {
                                              width: "0px !important",
                                              padding: "9px 0px !important",
                                            },
                                            width: "100%",
                                          }}
                                        />
                                      </div>
                                      <div
                                        style={{
                                          position: "absolute",
                                          bottom: "4px",
                                          left: "5px",
                                        }}
                                      >
                                        <Typography
                                          variant="subtitle2"
                                          sx={{
                                            opacity: 0.6,
                                            fontWeight: "600",
                                            fontSize: "12px",
                                          }}
                                        >{` @ Speed ${getKmhrForPace(
                                          item?.distance,
                                          item?.pace,
                                          item?.distanceType,
                                        )} km/hr or ${getMihrForPace(
                                          item?.distance,
                                          item?.pace,
                                          item?.distanceType,
                                        )} mi/hr`}</Typography>
                                      </div>
                                    </>
                                  )}
                                  {data.parameters.includes("Distance") && (
                                    <div
                                      className={`col-12 col-md-3 col-lg-2 pe-0 py-1`}
                                    >
                                      <TextField
                                        sx={{
                                          borderRadius: "5px",
                                          paddingRight: 0,
                                          width: "100%",
                                          marginTop: "5px",
                                        }}
                                        size="small"
                                        id="custom-input"
                                        variant="outlined"
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        placeholder={"Distance"}
                                        name="distance"
                                        label="Distance"
                                        value={item?.distance}
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        type="number"
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },

                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="distanceType"
                                                value={item?.distanceType}
                                                label="Weight Type"
                                                onChange={(e) => {
                                                  handleChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                onMouseLeave={() =>
                                                  handleMouseEnter(
                                                    index1,
                                                    mainindex,
                                                  )
                                                }
                                                onClick={() =>
                                                  handleMouseLeave()
                                                }
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": {
                                                    top: 0,
                                                  },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                }}
                                              >
                                                <MenuItem value="m">
                                                  Meter
                                                </MenuItem>
                                                <MenuItem value="km">
                                                  KM
                                                </MenuItem>
                                                <MenuItem value="mi">
                                                  Mile
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {(data.parameters.includes("Duration/Pace") ||
                                    data.parameters.includes("Time")) && (
                                    <div
                                      className={`col-12 col-md-3 col-lg-2 pe-0 py-1`}
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        placeholder="0"
                                        type="number"
                                        value={item?.time}
                                        name="time"
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        label={
                                          data.parameters.includes(
                                            "Duration/Pace",
                                          )
                                            ? "Duration/Pace"
                                            : "Time"
                                        }
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },

                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="timeType"
                                                value={item?.timeType}
                                                label="Weight Type"
                                                inputProps={{
                                                  style: {
                                                    padding: 0,
                                                  },
                                                }}
                                                onChange={(e) => {
                                                  handleChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": {
                                                    top: 0,
                                                  },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: 0,
                                                  },
                                                }}
                                              >
                                                <MenuItem value="sec">
                                                  sec
                                                </MenuItem>
                                                <MenuItem value="min">
                                                  min
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                          marginTop: "5px",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Reps") && (
                                    <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="Reps"
                                        type="number"
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        label="Reps"
                                        value={item?.reps}
                                        name="reps"
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: { fontSize: "13px" },
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Watts") && (
                                    <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="Watts"
                                        type="number"
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        label="Watts"
                                        value={item?.watts}
                                        name="watts"
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: { fontSize: "13px" },
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Max_Reps") && (
                                    <div className="col-12 col-md-2 col-lg-1 pe-0 py-2">
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="Max Reps"
                                        type="number"
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        label="Max Reps"
                                        value={item?.maxReps}
                                        name="maxReps"
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: { fontSize: "13px" },
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Height") && (
                                    <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="0"
                                        type="number"
                                        value={item?.height}
                                        name="height"
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: {
                                            fontSize: "14px",
                                          },
                                        }}
                                        label="Height"
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="height_unit"
                                                value={item?.height_unit}
                                                label="Height Type"
                                                inputProps={{
                                                  style: {
                                                    padding: 0,
                                                  },
                                                }}
                                                onChange={(e) => {
                                                  handleChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": {
                                                    top: 0,
                                                  },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: 0,
                                                  },
                                                }}
                                              >
                                                <MenuItem value="cm">
                                                  Cm
                                                </MenuItem>
                                                <MenuItem value="ft">
                                                  Feet
                                                </MenuItem>
                                                <MenuItem value="inch">
                                                  Inch
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Weight") && (
                                    <div className="col-12 col-md-4 col-lg-2 pe-0 py-2">
                                      <TextField
                                        sx={{
                                          borderRadius: "5px",
                                          paddingRight: 0,
                                          width: "100%",
                                        }}
                                        size="small"
                                        id="custom-input"
                                        variant="outlined"
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        placeholder="Weight"
                                        name="weight"
                                        label="Weight"
                                        value={item.weight}
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        type="number"
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="weightType"
                                                value={item?.weightType}
                                                label="Weight Type"
                                                onChange={(e) => {
                                                  handleChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                onMouseLeave={() =>
                                                  handleMouseEnter(
                                                    index1,
                                                    mainindex,
                                                  )
                                                }
                                                onClick={() =>
                                                  handleMouseLeave()
                                                }
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": { top: 0 },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                }}
                                              >
                                                <MenuItem value="1rm">
                                                  % 1RM
                                                </MenuItem>
                                                <MenuItem value="body_weight">
                                                  % BW
                                                </MenuItem>
                                                <MenuItem value="kg">
                                                  KG
                                                </MenuItem>
                                                <MenuItem value="lb">
                                                  Pound
                                                </MenuItem>
                                                <MenuItem value="poods">
                                                  Poods
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes(
                                    "Distance/Calories",
                                  ) && (
                                    <div className="col-12 col-md-3 col-lg-2 pe-0 py-2">
                                      <TextField
                                        sx={{
                                          borderRadius: "5px",
                                          paddingRight: 0,
                                          width: "100%",
                                        }}
                                        size="small"
                                        id="custom-input"
                                        variant="outlined"
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        placeholder={
                                          item?.distanceType == "calories"
                                            ? "Calories"
                                            : "Distance"
                                        }
                                        name="distance"
                                        label="Distance/Calories"
                                        value={item?.distance}
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        type="number"
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="distanceType"
                                                value={item?.distanceType}
                                                label="Weight Type"
                                                onChange={(e) => {
                                                  handleChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                onMouseLeave={() =>
                                                  handleMouseEnter(
                                                    index1,
                                                    mainindex,
                                                  )
                                                }
                                                onClick={() =>
                                                  handleMouseLeave()
                                                }
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": { top: 0 },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: 0,
                                                  },
                                                }}
                                              >
                                                <MenuItem value="m">
                                                  Meter
                                                </MenuItem>
                                                <MenuItem value="km">
                                                  KM
                                                </MenuItem>
                                                <MenuItem value="mi">
                                                  Mile
                                                </MenuItem>
                                                <MenuItem value="calories">
                                                  Calories
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("%MHR") && (
                                    <div className="col-12 col-md-2 col-lg-1 pe-0 py-1">
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="%MHR"
                                        type="number"
                                        label="%MHR"
                                        value={item?.mhr}
                                        name="mhr"
                                        onChange={(e) => {
                                          handleChangeTempo(
                                            e,
                                            mainindex,
                                            index1,
                                          );
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                          },
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                          marginTop: "5px",
                                          "& .MuiOutlinedInput-input": {
                                            padding: "8px 7px",
                                          },
                                        }}
                                      />
                                    </div>
                                  )}{" "}
                                  {data.parameters.includes("RPE") && (
                                    <div className="col-12 col-md-2 col-lg-1 pe-0 py-1">
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="RPE"
                                        label="RPE"
                                        value={item?.RPE}
                                        name="RPE"
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                          },
                                        }}
                                        sx={{
                                          borderRadius: "5px",
                                          fontSize: "13px",
                                          width: "100%",
                                          marginTop: "5px",
                                          "& .MuiOutlinedInput-input": {
                                            padding: "8px 7px",
                                          },
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Tempo") && (
                                    <div className="col-12 col-md-2 col-lg-1 pe-0 py-1">
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="Tempo"
                                        type="number"
                                        label="Tempo"
                                        value={item?.tempo}
                                        name="tempo"
                                        onChange={(e) => {
                                          handleChangeTempo(
                                            e,
                                            mainindex,
                                            index1,
                                          );
                                        }}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                          },
                                        }}
                                        sx={{
                                          borderRadius: "5px",

                                          fontSize: "13px",

                                          width: "100%",

                                          marginTop: "5px",

                                          "& .MuiOutlinedInput-input": {
                                            padding: "8px 7px",
                                          },
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Rest") && (
                                    <div className="col-12 col-md-3 col-lg-2 pe-0 py-1">
                                      <TextField
                                        id="outlined-basic"
                                        size="small"
                                        variant="outlined"
                                        placeholder="0"
                                        type="number"
                                        value={item?.rest}
                                        name="rest"
                                        onChange={(e) => {
                                          handleChange(e, mainindex, index1);
                                        }}
                                        onMouseLeave={() =>
                                          handleMouseEnter(index1, mainindex)
                                        }
                                        onClick={() => handleMouseLeave()}
                                        InputLabelProps={{
                                          className: "textfiels-input-label",
                                          shrink: true,
                                          style: { fontSize: "14px" },
                                        }}
                                        label="Rest"
                                        InputProps={{
                                          className: "textfiels-input-value",
                                          style: {
                                            fontSize: "13px",
                                            paddingRight: 0,
                                          },
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Select
                                                id="select-option"
                                                variant="outlined"
                                                size="small"
                                                name="restType"
                                                value={item?.restType}
                                                label="Weight Type"
                                                inputProps={{
                                                  style: {
                                                    padding: 0,
                                                  },
                                                }}
                                                onChange={(e) => {
                                                  handleChange(
                                                    e,
                                                    mainindex,
                                                    index1,
                                                  );
                                                }}
                                                sx={{
                                                  "& legend": {
                                                    display: "none",
                                                  },
                                                  "& fieldset": {
                                                    top: 0,
                                                  },
                                                  fontSize: "13px",
                                                  border: "none",
                                                  "& fieldset": {
                                                    border: "none",
                                                  },
                                                  "& .MuiOutlinedInput-input": {
                                                    padding: 0,
                                                  },
                                                }}
                                              >
                                                <MenuItem value="sec">
                                                  sec
                                                </MenuItem>
                                                <MenuItem value="min">
                                                  min
                                                </MenuItem>
                                              </Select>
                                            </InputAdornment>
                                          ),
                                        }}
                                        sx={{
                                          borderRadius: "5px",

                                          marginTop: "5px",
                                          fontSize: "13px",

                                          width: "100%",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {data.parameters.includes("Vdot") && (
                                    <div>
                                      {item?.race_type == "el" ? (
                                        <Typography
                                          variant="subtitle2"
                                          sx={{
                                            opacity: 0.6,
                                            fontWeight: "600",
                                            fontSize: "12px",
                                          }}
                                        >{` @ Speed ${getKmhr(
                                          item?.pace,
                                          item?.pace_type,
                                        )} km/hr or ${getMihr(
                                          item?.pace,
                                          item?.pace_type,
                                        )} mi/hr -  ${getKmhr(
                                          item?.paceUp,
                                          item?.pace_type,
                                        )} km/hr or ${getMihr(
                                          item?.paceUp,
                                          item?.pace_type,
                                        )} mi/hr`}</Typography>
                                      ) : (
                                        <Typography
                                          variant="subtitle2"
                                          sx={{
                                            opacity: 0.6,
                                            fontWeight: "600",
                                            fontSize: "12px",
                                          }}
                                        >{` @ Speed ${getKmhr(
                                          item?.pace,
                                          item?.pace_type,
                                        )} km/hr or ${getMihr(
                                          item?.pace,
                                          item?.pace_type,
                                        )} mi/hr`}</Typography>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      {data?.open && (
                        <>
                          <div className="d-flex justify-content-end mt-3">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled={
                                      data.parameters.includes("Vdot") &&
                                      !member_vdot
                                    }
                                    sx={{ p: "3px" }}
                                    checked={data.is_completed}
                                    onChange={(e) =>
                                      handleChangeComplete(e, mainindex)
                                    }
                                  />
                                }
                                label="Mark as Complete"
                              />
                            </FormGroup>
                          </div>
                        </>
                      )}
                      {data?.open && (
                        <div className="row mt-3 d-flex justify-content-center">
                          <div className="col-md-2 col-lg-1 col-3">
                            <button
                              onClick={(e) => {
                                e.preventDefault();

                                handleArrow(false, mainindex);
                              }}
                              className="w-100 small-contained-set-button"
                            >
                              <KeyboardArrowUpIcon
                                sx={{
                                  cursor: "pointer",
                                  opacity: 0.5,
                                  fontSize: "20px",
                                }}
                                onClick={() => {
                                  handleArrow(false, mainindex);
                                }}
                              />
                            </button>
                          </div>
                        </div>
                      )}
                    </Box>
                  </div>
                )}
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default WorkoutExercisesAnswerUI;
